import axios from "axios/index";
import {getAPIUrl} from "@esnpm/node-toolbox";
import Promise from "bluebird";
export const API_NEWSLETTER_OPT_IN_REQUEST = "API_NEWSLETTER_OPT_IN_REQUEST";
export const API_NEWSLETTER_OPT_IN_SUCCESS = "API_NEWSLETTER_OPT_IN_SUCCESS";
export const API_NEWSLETTER_OPT_IN_FAILURE = "API_NEWSLETTER_OPT_IN_FAILURE";

export const api_newsletter_opt_in_request = (options) => {
	return {
		type: API_NEWSLETTER_OPT_IN_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

export const api_newsletter_opt_in_success = (data) => {
	return {
		type: API_NEWSLETTER_OPT_IN_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

export const api_newsletter_opt_in_failure = (error) => {
	return {
		type: API_NEWSLETTER_OPT_IN_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Newsletter.apiNewsletterOptIn
*/
export const apiNewsletterOptIn = (options) =>
	// eslint-disable-next-line no-unused-vars
	(dispatch, getState) => new Promise(
		// eslint-disable-next-line no-unused-vars
		(resolve, reject) => {
			dispatch(api_newsletter_opt_in_request(options));
			const url=getAPIUrl([
				{"url": "/api/newsletter/optin", "parameters": []},
			], options);
			axios({
				method: "get",
				url: url,
				params: {
					OPTIN_HASH: options.OPTIN_HASH,
				},
			}).then(
				(response) => {
					if (response.data.SUCCESSFUL) {
						dispatch(api_newsletter_opt_in_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_newsletter_opt_in_failure(response.data));
						resolve();
					}
				},
				(err) => {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				}
			);
		}
	);
